/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider, Grid } from '@mui/material';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import SaveIcon from '@mui/icons-material/Save';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
// import SaveFilterPopover from '../Popovers/SaveFilterPopover/SaveFilterPopover';
import WidgetCard from '../Cards/WidgetCard/WidgetCard';
// import { autoCompleteDataFetcher, objectTypes } from '../../services/GenericService/GenericService';
import { PetrohubClientAutoComplete } from '../AutoComplete';
// import RemoteDataAutoComplete from '../AutoComplete/CustomAutoComplete/RemoteDataAutoComplete';
import { blurEffectProps } from '../Cards/Effects/blurEffect';
// import commonApi from '../../services/api/CommonApi';

export default function GlobalFiltersPannel(props) {
  const { userGlobalFilterPetroHub, onResetFilterHandler, onSaveFilterHandler } = props;
  const [userFilter, setUserFilter] = useState(userGlobalFilterPetroHub);
  const { t } = useTranslation();

  // Helper to get value by field name
  const getFieldValue = (field) => {
    const fields = userFilter[0]?.Fields || [];
    return fields.find((f) => f.Field === field)?.Value || [];
  };

  // Update the value for a specific field
  const handleChange = useCallback((field, value) => {
    setUserFilter((prev) => {
      const updatedFields = prev[0].Fields.map((f) =>
        (f.Field === field ? { ...f, Value: value } : f));
      return [{ Fields: updatedFields }];
    });
  }, []);

  // Memoized values for clientIds and addressIds
  const clientIds = useMemo(
    () => getFieldValue('clientIDs')?.map((c) => c.id),
    [userFilter]
  );
  // const addressIds = useMemo(
  //   () => getFieldValue('reportAddressIDs').map((addr) => addr.id),
  //   [userFilter]
  // );
  // **NEW: Reset dependent filters only when clients are REMOVED**
  const prevClientIdsRef = useRef(clientIds || []);
  useEffect(() => {
    const prevIds = prevClientIdsRef.current;
    const currentIds = clientIds || [];

    // Check if any client was removed (current ids are fewer or different)
    const clientRemoved = prevIds.length > currentIds.length ||
      prevIds.some((id) => !currentIds.includes(id));

    if (clientRemoved && prevIds.length > 0) {
      setUserFilter((prev) => {
        const updatedFields = prev[0].Fields.map((f) => {
          // Reset reportAddressIDs and ScenarioID only when clients are removed
          if (f.Field === 'reportAddressIDs' || f.Field === 'ScenarioID') {
            return { ...f, Value: [] };
          }
          return f;
        });
        return [{ Fields: updatedFields }];
      });
    }

    // Update the ref with current client IDs for next comparison
    prevClientIdsRef.current = currentIds;
  }, [clientIds]);

  return (
    <WidgetCard
      title={t('Label_GlobalFilter')}
      bodyPadding={0}
      sx={{ ...blurEffectProps }}
      icon={<FilterAltOutlinedIcon color="action" fontSize="small" />}
      body={
        <>
          {userFilter && (
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                {/* Client Filter */}
                <Grid item xs={12}>
                  <PetrohubClientAutoComplete
                    label={t('Label_Client')}
                    required
                    multiple
                    renderOptionDecorator
                    isFetchAllClients
                    selectedClientList={getFieldValue('clientIDs')}
                    selectedItem={getFieldValue('clientIDs')}
                    onValueChange={(val) => handleChange('clientIDs', val)}
                    pageSize={50}
                    serverFilter
                    parameter={{
                      sourceSystemIds: [],
                      divisionIds: [],
                    }}
                    error={getFieldValue('clientIDs').length === 0}
                    helperText={
                      getFieldValue('clientIDs').length === 0 ? t('Error_ClientIsRequired') : null
                    }
                    size="small"
                    variant="outlined"

                  />
                </Grid>

                {/* Report Address Filter */}
                {/* <Grid item xs={12}>
                  <RemoteDataAutoComplete
                    label={t('Label_ReportAddress')}
                    objectType={objectTypes.addresses}
                    fetcher={autoCompleteDataFetcher}
                    selectedItem={getFieldValue('reportAddressIDs')}
                    extraFilter={{
                      clientIds,
                      sourceSystemIds: [],
                      divisionIds: [],
                      addressType: null,
                    }}
                    onSelectedItemChanged={(val) => handleChange('reportAddressIDs', val)}
                    pageSize={50}
                    serverFilter
                    multiple
                    renderOptionDecoratorHandler={(propss, option) => (
                      <li {...propss} key={option.id}>
                        <Stack
                          direction="column"
                          justifyContent="flex-start"
                          spacing={0.5}
                          width="100%"
                        >
                          {option.text || ' '}
                          {option.sourceSystemRecordID && (
                            <Typography color="textSecondary" variant="inherit">
                              {option.sourceSystemRecordID} - {option.facility}
                            </Typography>
                          )}
                        </Stack>
                      </li>
                    )}
                    size="small"
                    variant="outlined"
                  />
                </Grid> */}

                {/* Scenario Filter */}
                {/* <Grid item xs={12}>
                  <RemoteDataAutoComplete
                    label={t('Label_Scenario')}
                    objectType={objectTypes.scenarios}
                    fetcher={autoCompleteDataFetcher}
                    selectedItem={getFieldValue('ScenarioID')}
                    onSelectedItemChanged={(val) => handleChange('ScenarioID', val)}
                    pageSize={50}
                    serverFilter
                    multiple
                    extraFilter={{
                      clientIds,
                      sourceSystemIds: [],
                      divisionIds: [],
                      addressIds,
                    }}
                    renderOptionDecoratorHandler={(propss, option) => (
                      <li {...propss} key={option.id}>
                        <Stack
                          direction="column"
                          justifyContent="flex-start"
                          spacing={0.5}
                          width="100%"
                        >
                          {option.text || ' '}
                          {option.masterDataItems?.length > 0 && (
                            <Typography color="textSecondary" variant="inherit">
                              {option.masterDataItems[0].MDItemField1}
                            </Typography>
                          )}
                        </Stack>
                      </li>
                    )}
                    size="small"
                    variant="outlined"
                  />
                </Grid> */}
              </Grid>
            </Box>
          )}
          <Box sx={{ px: 2 }}>
            {/* <Divider /> */}
            {t('Label_GlobalFilterNote')}
          </Box>
          <Divider />

          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'flex-end',
              pr: 1.5,
              py: 0.5,
            }}
          >
            {/* <SaveFilterPopover
              sx={{ m: 0.5 }}
              size="small"
              objectType={searchSavedUserFilter}
              getFieldValues={getFieldValuesHandler}
              setSavedPresetList={setSavedFilterPresetListHandler}
            /> */}
            <Button
              color="primary"
              size="small"
              startIcon={<ClearAllIcon fontSize="small" />}
              sx={{ m: 0.5 }}
              variant="outlined"
              onClick={onResetFilterHandler}
            >
              {t('Btn_ClearFilter')}
            </Button>
            <Button
              color="primary"
              size="small"
              startIcon={<SaveIcon fontSize="small" />}
              sx={{ m: 0.5 }}
              variant="outlined"
              onClick={() => onSaveFilterHandler(userFilter)}
            >
              {t('Btn_ApplyFilter')}
            </Button>
          </Box>
        </>
      }
    />
  );
}
